module.exports = __webpack_public_path__ + "img/245dabe.png";